import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentCont, ContentNote, ContentQuestion } from './ConfirmSurveyQuitModal.styles';
import Modal from '../../HOC/Modal/Modal';

interface IConfirmSurveyQuitModal {
  active: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ConfirmSurveyQuitModal: FC<IConfirmSurveyQuitModal> = ({
  active,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      active={active}
      title={t('viewSurvey.contents.modals.quit.title')}
      width="480px"
      buttonNames={{
        action: t('viewSurvey.contents.modals.quit.actions.confirm'),
        cancel: t('viewSurvey.contents.modals.quit.actions.cancel')
      }}
      callToAction={onConfirm}
      closeModal={onClose}
      top='150px'
    >
      <ContentCont>
        <ContentNote>{t('viewSurvey.contents.modals.quit.note')}</ContentNote>
        <ContentQuestion>{t('viewSurvey.contents.modals.quit.question')}</ContentQuestion>
      </ContentCont>
    </Modal>
  );
};
